import AdminModal from "../../../components/AdminModal";
import AdminInputDatePicker from "../../../components/AdminInputDatePicker";
import moment from "moment";
// import date_icon from "../../../../../icons/dashboard/date_icon.svg";
// import input_delete_x_icon from "../../../../../icons/input-delete-x-icon.svg";
import {
  PlusIcon,
  CalendarIcon,
  DeleteIcon
} from "../../../../../components/icons"

const plus_icon =
  "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/plus.svg";

const DuplicateTransferModal = ({
  show,
  onClose,
  recurringTravelDates,
  onSelectDate,
  onAddDate,
  onRemoveDate,
  loadingDuplicate,
  onDuplicate,
}) => {
  return (
    <AdminModal
      show={show}
      size="modal-lg"
      centered={false}
      onClose={onClose}
      title="Duplicate Transfer"
      isUsingLine={true}
    >
      <>
        <div className="tw:mb-4">
          <label className="tw:block tw:mb-4 tw:text-[14px] tw:font-[400]">
            Duplicate the transfer details on:
          </label>

          <div className="tw:grid tw:grid-cols-2 tw:gap-2">
            {recurringTravelDates?.map((item, index) => (
              <div key={index}>
                <AdminInputDatePicker
                  placeholder="Select Issue Date"
                  prefixIcon={<CalendarIcon color="#DBBE78"/>}
                  onSelectDate={onSelectDate}
                  mb=""
                  name="issueDate"
                  hasIndex={true}
                  index={index}
                  value={
                    recurringTravelDates[index]
                      ? moment(
                        recurringTravelDates[index],
                        "YYYY-MM-DD"
                      ).toDate()
                      : null
                  }
                  suffixIcon={index !== 0 && <DeleteIcon/>}
                  onSufixIconClick={() => onRemoveDate(index)}
                  dateFormat="MMM. d, yyyy (E)"
                />
              </div>
            ))}

            <div>
              <button
                className={`
                  tw:!flex
                  tw:!items-center
                  tw:!gap-2
                  tw:!px-8
                  tw:!py-2
                  tw:!rounded
                  tw:!bg-[#F9EDD3]
                  ${(recurringTravelDates.length % 2 !== 0 || recurringTravelDates.length === 1) ? "tw:!h-full" : "tw:!h-12"}
                `}
                onClick={onAddDate}
              >
                <PlusIcon />
                <span className="tw:!text-[14px] tw:!text-[#4E4E4E] tw:!font-[400]">Add Date or Period</span>
              </button>
            </div>
          </div>

          <label className="tw:block tw:mt-4 tw:text-[14px] tw:font-[400]">
            Repeat Transfer for: {" "}
            <span className="tw:!text-[14px] tw:!text-[#4E4E4E] tw:!font-[700]">
              {recurringTravelDates.length} days
            </span>
          </label>
        </div>

        {/* Buttons */}
        <div className="tw:flex tw:justify-center tw:gap-4 tw:!mt-8">
          <div className="tw:w-1/3">
            <button
              className="
                tw:!w-full
                tw:!h-11
                tw:!rounded
                tw:!border
                tw:!border-[#C9A227]
                tw:!py-2
                tw:!font-[400] 
                tw:!text-[14px]
              "
              onClick={onClose}
            >
              Cancel
            </button>
          </div>

          <div className="tw:w-1/3">
            <button
              disabled={loadingDuplicate}
              className="
                tw:!w-full
                tw:!h-11
                tw:!rounded
                tw:!bg-[#DBBE78]
                tw:!py-2
                tw:disabled:!opacity-50
                tw:disabled:!cursor-not-allowed
              "
              onClick={onDuplicate}
            >
              <span className="tw:!text-white tw:!font-[400] tw:!text-[14px]">
                {loadingDuplicate ? "Loading..." : "Duplicate"}
              </span>
            </button>
          </div>
        </div>
      </>
    </AdminModal>
  );
};

export default DuplicateTransferModal;
